{
    "DIVIDERS": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "VISITORS", "FAVORITES", "TRASH", "FREE_FROM_WIX"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["FAVORITES"],
            "default": "FREE_FROM_WIX"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "shape",
            "publicMediaRoot": "Dividers",
            "disableOrientationFilters": true,
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "WSR_ICONS": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": false,
        "canUseImageAnalysis": false,
        "helpId": "",
        "tabsList": {
            "open": ["TRASH", "FREE_FROM_WIX"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "FREE_FROM_WIX"
        },
        "networksList": {
            "open": [],
            "restrictedK12Networks": []
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "shape",
            "publicMediaRoot": "e6a08b7e-00df-4648-ade5-fc757e957d62,e46e506a-223d-4c5b-8955-58515cccdf34",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "WSR_ICONS_SMALL": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": false,
        "canUseImageAnalysis": false,
        "helpId": "",
        "tabsList": {
            "open": ["TRASH", "FREE_FROM_WIX"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "FREE_FROM_WIX"
        },
        "networksList": {
            "open": [],
            "restrictedK12Networks": []
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "shape",
            "publicMediaRoot": "e6a08b7e-00df-4648-ade5-fc757e957d62",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "WSR_ICONS_MEDIUM": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": false,
        "canUseImageAnalysis": false,
        "helpId": "",
        "tabsList": {
            "open": ["TRASH", "FREE_FROM_WIX"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "FREE_FROM_WIX"
        },
        "networksList": {
            "open": [],
            "restrictedK12Networks": []
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "shape",
            "publicMediaRoot": "e46e506a-223d-4c5b-8955-58515cccdf34",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "3D_IMAGE": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": false,
        "helpId": "",
        "tabsList": {
            "open": ["TRASH", "FREE_FROM_WIX"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "FREE_FROM_WIX"
        },
        "networksList": {
            "open": [],
            "restrictedK12Networks": []
        },
        "mediaParams": {
            "mediaType": "3d,picture,shape",
            "publicMediaRoot": "images,illustrations,vectorArt,basicShapes",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "BASE_UI_ICONS_SMALL": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": false,
        "canUseImageAnalysis": false,
        "helpId": "",
        "tabsList": {
            "open": ["TRASH", "FREE_FROM_WIX"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "FREE_FROM_WIX"
        },
        "networksList": {
            "open": [],
            "restrictedK12Networks": []
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "shape",
            "publicMediaRoot": "e323f422-814b-468b-8917-2262a4266865",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "BASE_UI_ICONS_MEDIUM": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": false,
        "canUseImageAnalysis": false,
        "helpId": "",
        "tabsList": {
            "open": ["TRASH", "FREE_FROM_WIX"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "FREE_FROM_WIX"
        },
        "networksList": {
            "open": [],
            "restrictedK12Networks": []
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "shape",
            "publicMediaRoot": "31a5481c-85e1-4fc5-93b8-4b9fc9f5c321",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "DESIGN_SYSTEMS_ILLUSTRATIONS": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": false,
        "canUseImageAnalysis": false,
        "helpId": "",
        "tabsList": {
            "open": ["TRASH", "FREE_FROM_WIX"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "FREE_FROM_WIX"
        },
        "networksList": {
            "open": [],
            "restrictedK12Networks": []
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "shape",
            "publicMediaRoot": "43291c63-f926-4741-8569-a9846c74e44d",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "BASEUI_THUMBS": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": false,
        "canUseImageAnalysis": false,
        "helpId": "",
        "tabsList": {
            "open": ["TRASH", "FREE_FROM_WIX"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "FREE_FROM_WIX"
        },
        "networksList": {
            "open": [],
            "restrictedK12Networks": []
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "shape",
            "publicMediaRoot": "baseUI_thumbs",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "IMAGE": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": true,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "HOME",
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [
                "HOME",
                "FAVORITES",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "picture",
            "publicMediaRoot": "images,illustrations",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "MENU_MEDIA": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": true,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["HOME", "MY_MEDIA", "VISITORS", "FAVORITES", "TRASH"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["HOME", "FAVORITES"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "picture,document",
            "mimeTypesAllowed": [
                "image/bmp",
                "image/gif",
                "image/heic",
                "image/heif",
                "image/tiff",
                "image/jpeg",
                "image/png",
                "image/webp",
                "image/jp2",
                "image/x-canon-cr2",
                "image/x-nikon-nef",
                "image/x-sony-arw",
                "image/x-adobe-dng",
                "application/pdf"
            ],
            "publicMediaRoot": "",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "SHAPE_ART": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "VISITORS", "FAVORITES", "TRASH", "FREE_FROM_WIX"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["FAVORITES"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "shape",
            "publicMediaRoot": "vectorArt,appIcons",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "SHAPE_BASIC": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "VISITORS", "FAVORITES", "TRASH", "FREE_FROM_WIX"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["FAVORITES"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "shape",
            "publicMediaRoot": "basicShapes,appIcons",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "SOCIAL_ICONS": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "VISITORS", "FAVORITES", "TRASH", "FREE_FROM_WIX"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["FAVORITES"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "shape",
            "publicMediaRoot": "socialIconsComponent",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "VIDEO": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": true,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "HOME",
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_VIDEO"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["HOME", "FAVORITES", "SHUTTER_STOCK_VIDEO"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "video",
            "publicMediaRoot": "videos",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "VIDEO_ALPHA": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": true,
        "canSubmitMediaBeforeEncodingComplete": true,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "HOME",
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["HOME", "FAVORITES"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "video",
            "publicMediaRoot": "transparentVideos",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "MUSIC": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "VISITORS", "FAVORITES", "TRASH"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["FAVORITES"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "music",
            "publicMediaRoot": "",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "DOCUMENT": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "VISITORS", "FAVORITES", "TRASH"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["FAVORITES"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "document,archive",
            "publicMediaRoot": "",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "ICON_DOCUMENT": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": true,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [
                "FAVORITES",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE"
            ],
            "default": "FREE_FROM_WIX"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "picture",
            "publicMediaRoot": "file_icons",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "ICON_SOCIAL": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [
                "FAVORITES",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE"
            ],
            "default": "FREE_FROM_WIX"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "picture",
            "publicMediaRoot": "social_icons",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "ICON_FAVICON": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "HOME",
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [
                "HOME",
                "FAVORITES",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE"
            ],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "site_icon,picture",
            "publicMediaRoot": "images,illustrations",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "FLASH": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "VISITORS", "FAVORITES", "TRASH"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["FAVORITES"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "swf",
            "publicMediaRoot": "",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "ALL_MEDIA": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": true,
        "canSubmitMediaBeforeEncodingComplete": true,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "HOME",
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_IMAGE",
                "SHUTTER_STOCK_VIDEO",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [
                "HOME",
                "FAVORITES",
                "SHUTTER_STOCK_IMAGE",
                "SHUTTER_STOCK_VIDEO",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "picture,video,shape,music,document,swf,archive",
            "publicMediaRoot": "images,videos,transparentVideos,illustrations,vectorArt,basicShapes,social_icons,appIcons",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "STUDIO_CLIENT_HANDOVER_KIT": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": true,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": true,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "TRASH", "FREE_FROM_WIX"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "picture,video,shape,document",
            "publicMediaRoot": "partnersClientKit",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "BG_MEDIA": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": true,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "HOME",
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_IMAGE",
                "SHUTTER_STOCK_VIDEO",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [
                "HOME",
                "FAVORITES",
                "SHUTTER_STOCK_IMAGE",
                "SHUTTER_STOCK_VIDEO",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "picture,video",
            "publicMediaRoot": "bg_images,videos,bg_illustrations,patterns,textures",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "WIX_MUSIC": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": true,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "TRASH"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": ["WIX_SITES", "GOOGLE_DRIVE", "DROPBOX", "EXTERNAL_URL"],
            "restrictedK12Networks": ["DROPBOX"]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "secure_music",
            "publicMediaRoot": "",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": "_nsWixMusic"
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "WIX_VIDEO": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": true,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "TRASH"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "secure_video",
            "publicMediaRoot": "",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": "_nsWixVideo"
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "VIDEO_MAKER": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "HOME",
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_IMAGE",
                "SHUTTER_STOCK_VIDEO",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [
                "HOME",
                "FAVORITES",
                "SHUTTER_STOCK_IMAGE",
                "SHUTTER_STOCK_VIDEO",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "picture,video",
            "publicMediaRoot": "images,videos,illustrations",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "VIDEO_BOX": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": true,
        "canSubmitMediaBeforeEncodingComplete": true,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "HOME",
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_VIDEO"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["HOME", "FAVORITES", "SHUTTER_STOCK_VIDEO"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "video",
            "publicMediaRoot": "videos,transparentVideos",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "VIDEO_BOX_MASK": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": true,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "HOME",
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_VIDEO"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["HOME", "FAVORITES", "SHUTTER_STOCK_VIDEO"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "video",
            "publicMediaRoot": "videos",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "VECTOR_ART": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "VISITORS", "FAVORITES", "TRASH", "FREE_FROM_WIX"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["FAVORITES"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "shape",
            "publicMediaRoot": "vectorArt,basicShapes,appIcons",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "ART_STORE": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": true,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "TRASH"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "secure_picture",
            "publicMediaRoot": "",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": "_nsArtStore"
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "PHYSICAL_PRODUCT": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "HOME",
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_IMAGE",
                "SHUTTER_STOCK_VIDEO",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [
                "HOME",
                "FAVORITES",
                "SHUTTER_STOCK_IMAGE",
                "SHUTTER_STOCK_VIDEO",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "picture,video",
            "publicMediaRoot": "images,videos,illustrations",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "DIGITAL_PRODUCT": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "TRASH"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "secure_picture,secure_video,secure_music,secure_document,secure_archive",
            "publicMediaRoot": "",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": "_nsDigitalProduct"
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "PRO_GALLERY": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": true,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "HOME",
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_IMAGE",
                "SHUTTER_STOCK_VIDEO",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [
                "HOME",
                "FAVORITES",
                "SHUTTER_STOCK_IMAGE",
                "SHUTTER_STOCK_VIDEO",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "picture,video",
            "publicMediaRoot": "images,videos,illustrations",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "PHOTO_ALBUM": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": true,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["HOME", "MY_MEDIA", "VISITORS", "FAVORITES", "TRASH"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["HOME", "FAVORITES"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "picture,video",
            "publicMediaRoot": "",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "WELCOME_SCREEN": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "HOME",
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [
                "HOME",
                "FAVORITES",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "picture,shape",
            "publicMediaRoot": "images,illustrations,vectorArt,basicShapes",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "STYLABLE_BUTTON_ICON": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "VISITORS", "FAVORITES", "TRASH", "FREE_FROM_WIX"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["FAVORITES"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "shape",
            "publicMediaRoot": "buttons",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "MANAGE_MEDIA": {
        "canSubmitMedia": false,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": true,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "HOME",
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_IMAGE",
                "SHUTTER_STOCK_VIDEO",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [
                "HOME",
                "FAVORITES",
                "SHUTTER_STOCK_IMAGE",
                "SHUTTER_STOCK_VIDEO",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "picture,video,shape,music,document,swf,archive",
            "publicMediaRoot": "images,videos,transparentVideos,illustrations,vectorArt,basicShapes,social_icons",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": false,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "PRINT_SHOP": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": true,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "VISITORS", "FAVORITES", "TRASH"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["FAVORITES"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "picture",
            "publicMediaRoot": "images,illustrations",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "BG_IMAGE": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [
                "FAVORITES",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "picture",
            "publicMediaRoot": "bg_images,bg_illustrations,patterns,textures",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "BG_VIDEO": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": true,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_VIDEO"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["FAVORITES", "SHUTTER_STOCK_VIDEO"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "video",
            "publicMediaRoot": "videos",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "DESIGN_VIDEO": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": true,
        "canSubmitMediaBeforeEncodingComplete": true,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_VIDEO"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["FAVORITES", "SHUTTER_STOCK_VIDEO"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "video",
            "publicMediaRoot": "videos,transparentVideos",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "ART_STORE_IMAGE": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": true,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "TRASH"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "secure_picture",
            "publicMediaRoot": "",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": "_nsArtStore"
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "DIGITAL_PRODUCT_IMAGE": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "TRASH"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "secure_picture",
            "publicMediaRoot": "",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": "_nsDigitalProduct"
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "DIGITAL_PRODUCT_VIDEO": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "TRASH"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "secure_video",
            "publicMediaRoot": "",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": "_nsDigitalProduct"
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "DIGITAL_PRODUCT_MUSIC": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "TRASH"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "secure_music",
            "publicMediaRoot": "",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": "_nsDigitalProduct"
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "DIGITAL_PRODUCT_DOCUMENT": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "TRASH"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "secure_document",
            "publicMediaRoot": "",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": "_nsDigitalProduct"
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "DIGITAL_PRODUCT_ZIP": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "TRASH"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "secure_archive",
            "publicMediaRoot": "",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": "_nsDigitalProduct"
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "IMAGE_PRO": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": true,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "TRASH"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "secure_picture",
            "publicMediaRoot": "",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": "_nsArtStore"
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "MUSIC_PRO": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "TRASH"],
            "manage": [],
            "restrict": [],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "FACEBOOK",
                "GOOGLE_DRIVE",
                "DROPBOX",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": ["FACEBOOK", "DROPBOX"]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "secure_music",
            "publicMediaRoot": "",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": "_nsWixMusic"
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "IMAGE_UOU": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [
                "FAVORITES",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE"
            ],
            "default": "VISITORS"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "picture",
            "publicMediaRoot": "images",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "VIDEO_UOU": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": true,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_VIDEO"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["FAVORITES", "SHUTTER_STOCK_VIDEO"],
            "default": "VISITORS"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "VIMEO",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "video",
            "publicMediaRoot": "videos",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "DOCUMENT_UOU": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "VISITORS", "FAVORITES", "TRASH"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["FAVORITES"],
            "default": "VISITORS"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "document,archive",
            "publicMediaRoot": "",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "SHAPE": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "VISITORS", "FAVORITES", "TRASH", "FREE_FROM_WIX"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["FAVORITES"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "shape",
            "publicMediaRoot": "vectorArt,basicShapes,appIcons",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "CURSOR": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "VISITORS", "FAVORITES", "TRASH", "FREE_FROM_WIX"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["FAVORITES"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "picture,shape",
            "publicMediaRoot": "vectorArt",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "CLIPART": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [
                "FAVORITES",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE"
            ],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "picture",
            "publicMediaRoot": "images,illustrations",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "AUTO_CMS_IMAGE": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "HOME",
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [
                "HOME",
                "FAVORITES",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "picture,shape",
            "publicMediaRoot": "images,illustrations,vectorArt,basicShapes",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "CERT_BACKGROUNDS": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": true,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": true,
        "helpId": "",
        "tabsList": {
            "open": [
                "HOME",
                "MY_MEDIA",
                "VISITORS",
                "FAVORITES",
                "TRASH",
                "FREE_FROM_WIX",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": [
                "HOME",
                "FAVORITES",
                "SHUTTER_STOCK_IMAGE",
                "UNSPLASH_IMAGE",
                "NTT"
            ],
            "default": "FREE_FROM_WIX"
        },
        "networksList": {
            "open": [
                "WIX_SITES",
                "GOOGLE_DRIVE",
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE",
                "EXTERNAL_URL"
            ],
            "restrictedK12Networks": [
                "FACEBOOK",
                "INSTAGRAM",
                "DROPBOX",
                "GOOGLE_PHOTOS",
                "FLICKR",
                "DEVIANT_ART",
                "500PX",
                "DRIBBLE"
            ]
        },
        "mediaParams": {
            "mediaType": "picture",
            "publicMediaRoot": "certificateBackgrounds,images",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    },
    "SOCIAL_ICONS_MOBILE": {
        "canSubmitMedia": true,
        "canSubmitMultipleMedia": false,
        "canSubmitTransparentVideos": false,
        "canSubmitMediaBeforeEncodingComplete": false,
        "canUploadMedia": true,
        "canUseImageAnalysis": false,
        "helpId": "",
        "tabsList": {
            "open": ["MY_MEDIA", "FAVORITES", "TRASH", "FREE_FROM_WIX"],
            "manage": [],
            "restrictedTabs": [],
            "restrictedK12Tabs": ["FAVORITES"],
            "default": "MY_MEDIA"
        },
        "networksList": {
            "open": [],
            "restrictedK12Networks": []
        },
        "mediaParams": {
            "i18nPrefix": [],
            "mediaType": "shape",
            "publicMediaRoot": "social_icons_mobile",
            "videoEncodingProfile": "mp4-storyboard",
            "namespace": ""
        },
        "translationsList": {
            "title": true,
            "submitCaption": true,
            "uploadCaption": false,
            "tabCaption": false,
            "description": false,
            "noItems": false,
            "removeItems": false
        }
    }
}
